import api from '../../../services/api';

const API_URL = '/api/v1/admin/notification';
/**
 * @returns {Promise<ApiAdmin.GetAllGenericNotifications>}
 */
// eslint-disable-next-line import/prefer-default-export
export const getGenericNotificationList = () => api.get(API_URL);

/**
 * @returns {Promise<ApiAdmin.GetNotificationTagListResponse>}
 */
export const getNotificationTagList = () => api.get(`${API_URL}/tags`);
